module.exports = __webpack_public_path__ + "img/Macedonia.095cedf2.svg";